<script setup>
// ============================================================================
// BonBoZ: biểu đồ CẢM XÚC theo ngày — HAI ĐƯỜNG trên một trục (đổi từ dạng
// cột gương theo yêu cầu 24/08/2026): đường xanh tích cực, đường đỏ tiêu cực,
// nền tô nhạt dưới mỗi đường để hai vùng vẫn so được diện tích với nhau.
//
// Điểm (point) để bật rõ trên từng ngày — dữ liệu thưa (vài tin một ngày),
// đường trơn không điểm sẽ trông như nội suy ra số liệu không có thật.
//
// Màu lấy từ biến theme qua scriptable option — cùng lý do và cùng cách với
// `helper/mauBieuDo.js`: đổi nền tối là màu tự bám theo.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';
import { mauCss } from 'dashboard/helper/mauBieuDo';

const props = defineProps({
  nhan: { type: Array, default: () => [] },
  tichCuc: { type: Array, default: () => [] },
  tieuCuc: { type: Array, default: () => [] },
  tenTichCuc: { type: String, default: '' },
  tenTieuCuc: { type: String, default: '' },
});

// Đăng ký trong thân setup, KHÔNG trong onMounted: onMounted của cha chạy SAU
// của con, mà `<Chart>` (con) dựng biểu đồ ngay trong onMounted của nó — bẫy
// đã dính một lần ở `BieuDoTron.vue`, canvas trắng vĩnh viễn.
ChartJS.register(
  Tooltip,
  Legend,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

// `tension` 0.3: hơi cong cho dễ theo, chưa tới mức vẽ ra đỉnh giả giữa hai
// mốc. Nền `mo 0.12` đủ thấy vùng, không che đường kia khi hai vùng đè nhau.
const motDuong = (ten, duLieuDiem, bien) => ({
  label: ten,
  data: duLieuDiem,
  borderColor: () => mauCss(bien),
  backgroundColor: () => mauCss(bien, 0.12),
  pointBackgroundColor: () => mauCss(bien),
  pointRadius: 3,
  pointHoverRadius: 5,
  borderWidth: 2,
  tension: 0.3,
  fill: true,
});

const duLieu = computed(() => ({
  labels: props.nhan,
  datasets: [
    motDuong(props.tenTichCuc, props.tichCuc, '--bonboz-xong'),
    motDuong(props.tenTieuCuc, props.tieuCuc, '--bonboz-tre'),
  ],
}));

const tuyChon = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: { grid: { display: false } },
    // Tin nhắn đếm bằng số nguyên — thang lẻ 0,5 tin là thang vô nghĩa.
    y: { beginAtZero: true, ticks: { precision: 0 } },
  },
  plugins: { legend: { position: 'bottom' } },
};
</script>

<template>
  <Chart type="line" :data="duLieu" :options="tuyChon" />
</template>
